import { lazy } from "react";

const ProductList = lazy(() =>
  import("./ProductList").then((m) => ({ default: m.ProductList })),
);
const ProductCreate = lazy(() =>
  import("./ProductCreate").then((m) => ({ default: m.ProductCreate })),
);
const ProductEdit = lazy(() =>
  import("./ProductEdit").then((m) => ({ default: m.ProductEdit })),
);

export default {
  list: ProductList,
  create: ProductCreate,
  edit: ProductEdit,
  recordRepresentation: "name",
};
